import { useContext } from 'react';
import { NavigationContext } from '../../context/NavigationContext';
import { Step, StepContainer, SVGContainer } from 'shared/components';
import CheckedSvg from 'images/shared/checked.svg';
import BespaarcheckSvg from 'images/hypotheekbespaarcheck/logo.svg';

export default function Steps() {
  const { activeFlow, activeFlowStepIndex, updateFlowIndex } = useContext(NavigationContext);
  const maxWidth = activeFlow.length * 60;

  return (
    <StepContainer maxWidth={maxWidth}>
      {activeFlow.map((_, index) => {
        const completed = activeFlowStepIndex > index;
        const active = activeFlowStepIndex === index;

        if (index === activeFlow.length - 1) {
          return (
            <SVGContainer active={activeFlowStepIndex === activeFlow.length - 1} key={index}>
              <BespaarcheckSvg />
            </SVGContainer>
          );
        }

        return (
          <Step
            active={active}
            completed={completed}
            key={index}
            onClick={() => updateFlowIndex(index)}
            disabled={!completed}
          >
            {completed ? <CheckedSvg /> : index + 1}
          </Step>
        );
      })}
    </StepContainer>
  );
}
